import { render, staticRenderFns } from "./rewardSerialPackEdit.vue?vue&type=template&id=18c7cc48&scoped=true&"
import script from "./rewardSerialPackEdit.vue?vue&type=script&lang=js&"
export * from "./rewardSerialPackEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c7cc48",
  null
  
)

export default component.exports